module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO48VIgileSuPatrimonio.a7be96b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO48VIgileSuPatrimonio.mp4
// module id = 774
// module chunks = 1